import { render, staticRenderFns } from "./HelpBannerComponent.vue?vue&type=template&id=053d4b79"
import script from "./HelpBannerComponent.vue?vue&type=script&lang=js"
export * from "./HelpBannerComponent.vue?vue&type=script&lang=js"
import style0 from "./HelpBannerComponent.vue?vue&type=style&index=0&id=053d4b79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports